/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dialogue_List_Export_Drop_FrameInputs */



/**
* | output |
* | --- |
* | "Drop frame" |
*
* @param {Dialogue_List_Export_Drop_FrameInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const dialogue_list_export_drop_frame = /** @type {((inputs?: Dialogue_List_Export_Drop_FrameInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dialogue_List_Export_Drop_FrameInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Drop frame")
	if (locale === "de") return /** @type {LocalizedString} */ ("Fallrahmen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Telaio a goccia")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Опускающаяся рама")
	if (locale === "es") return /** @type {LocalizedString} */ ("Marco de caída")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("掉帧")
	if (locale === "ja") return /** @type {LocalizedString} */ ("ドロップフレーム")
	if (locale === "hi") return /** @type {LocalizedString} */ ("ड्रॉप फ्रेम")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Quadro de queda")
	return /** @type {LocalizedString} */ ("Drop frame")
});